@let firstPointTimestamp = this.firstPointData();
@let lastPointTimestamp = this.lastPointData();
@let isTimeEstimated =
  firstPointTimestamp?.isEstimated || lastPointTimestamp?.isEstimated;

<onyx-data-widget
  [supheading]="
    isOrderFinished()
      ? 'labels.durationTime'
      : isTimeEstimated
        ? `${I18N}.estimatedDuration`
        : `${I18N}.maxDuration`
  "
  [headingIcon]="{ name: 'clock-filled', size: 20, color: 'black' }"
>
  <div heading class="heading">
    {{
      lastPointTimestamp.timestamp
        | diff: firstPointTimestamp.timestamp
        | duration
    }}
  </div>

  <div class="list">
    <div class="item">
      <p class="f-muted">
        {{
          `labels.${firstPointTimestamp.isEstimated ? 'eta' : 'from'}`
            | translate
        }}
      </p>

      <div class="date">
        {{
          firstPointTimestamp.timestamp
            | onyxDate: 'time-date-dot' : { separator: ' · ' }
        }}
      </div>
    </div>

    <div class="item">
      <p class="f-muted">
        {{
          `labels.${lastPointTimestamp.isEstimated ? 'etd' : 'to'}` | translate
        }}
      </p>

      <div class="date">
        {{
          lastPointTimestamp.timestamp
            | onyxDate: 'time-date-dot' : { separator: ' · ' }
        }}
      </div>
    </div>
  </div>
</onyx-data-widget>
